import { TypographyParagraph, TypographyLabel } from '../../typography'
import TypographyHeader from '../../typography/TypographyHeading'
import { CommentIcon } from '../../icons'

type CommentProps = {
  metadata: {
    properties?: {
			description?: string;
			title?: string;
    };
  };
}

export default function Comment({ metadata }: CommentProps) {
  const { properties } = metadata;

  return (
    <div className="flex flex-col space-y-2">
			<div className="flex flex-col">
				<TypographyHeader size="small" additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark">
					{properties.title || 'No title'}
				</TypographyHeader>
			</div>

      {/* Comment Text */}
			<TypographyParagraph size="small" additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark mt-2">
				{properties.description?.slice(0, 334)}
				{properties.description && properties.description.length > 334 && '...'}
			</TypographyParagraph>
    </div>
  );
} 